import { render } from "./MasterTable.vue?vue&type=template&id=4e08142c"
import script from "./MasterTable.vue?vue&type=script&lang=js"
export * from "./MasterTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__